import styled from 'styled-components'
import { spacing, shape, transition, color, Media } from '@foxrenderfarm/common/src/theme'

export const Label = styled.label`
  cursor: pointer;
  display: flex;
  color: ${color.text};
  margin-bottom: ${spacing.small};
  & + & {
    margin-left: ${spacing.small};
  }
  > span {
    margin-left: 5px;
  }
  ${(p) =>
    p.disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
    > input {
      cursor: not-allowed;
    }
  `}
`

export const Input = styled.input`
  cursor: pointer;
  appearance: none;
  position: relative;
  width: ${spacing.base};
  height: ${spacing.base};
  border: 1px solid ${color.grey};
  border-radius: ${shape.radiusSmall};
  transition: ${transition(['border', 'background-color'])};
  margin-right: ${spacing.small};
  flex-shrink: 0;
  :active,
  :focus {
    outline: 0;
  }
  :not([disabled]):hover {
    border-color: ${color.primary};
  }
  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 7px;
    width: 5px;
    height: 10px;
    transform: rotate(43deg) scale(0);
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    background-color: transparent;
    transition: ${transition(['transform', 'border-color'])};
  }
  &:checked {
    border-color: ${color.primary};
    &::before {
      border-color: ${color.primary};
      transform: rotate(43deg) scale(1);
    }
  }
  ${Media.lessThan(Media.small)} {
    margin-top: 0;
  }
`
